import { TeamInfo } from 'modules/teams/domain/interfaces/team';
import { TeamPlayer } from 'modules/teams/domain/interfaces/team-player';
import TeamCardPlayer from 'modules/teams/ui/components/team-card/team-card-player';
import React from 'react';
import UDCheckbox from 'ud-form/components/checkbox/component';
import TeamLogo from 'ud-ui/components/team-logo';
import { SymbolicTeamFormation } from 'modules/championship/domain/enums/symbolic-team-formation';
import { SelectedPlayer } from 'modules/championship/domain/interfaces/selected-player';
import { PlayerRank } from './player-rank';
import { PlayerAdditional, PlayerContainer } from './player.styles';

type PlayerProps = {
  formation: SymbolicTeamFormation;
  team: TeamInfo;
  player: TeamPlayer;
  selectedPlayers: SelectedPlayer[];
  onPlayerSelect?: (player: TeamPlayer, team: TeamInfo) => void;
};

export const Player = (props: PlayerProps) => {
  const { formation, team, player, selectedPlayers, onPlayerSelect } = props;

  const currentSelectedPlayer = selectedPlayers.find((item) => item.userId === player.userId);
  const isSelected = !!currentSelectedPlayer;

  return (
    <PlayerContainer>
      <div>
        <UDCheckbox checked={isSelected} onChange={() => onPlayerSelect && onPlayerSelect(player, team)} />
      </div>
      <div className="player-info-container">
        <TeamCardPlayer className="team-player-item" key={player.id} player={player} />
        <PlayerAdditional>
          {currentSelectedPlayer && <PlayerRank className="mr-2" formation={formation} rank={currentSelectedPlayer.rank} />}
          <TeamLogo className="team-logo mr-2" url={team.logo?.url} name={team.name} size={42} />
        </PlayerAdditional>
      </div>
    </PlayerContainer>
  );
};
